<template>
  <div class="item-paragraph" v-html="item.text"/>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';
@import 'node_modules/bootstrap/scss/bootstrap-grid.scss';

div {
  padding: 1.25rem;
}

@include media-breakpoint-down(xs) {
  div {
    padding: $spacing-xs;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/items/paragraph.vue